
            const data = {"name":"streamline-icons/Outline version/52-Arrows-Diagrams/01-Arrows/arrow-right-1","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M5.499 24a.752.752 0 01-.53-1.281L15.689 12 4.969 1.28c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53c.141-.142.33-.22.53-.22s.389.078.53.22l10.72 10.72a1.5 1.5 0 01.001 2.119L6.029 23.78a.743.743 0 01-.53.22z\"/>"}}
        
                module.exports = data
                